import React from 'react';

export const PendingContext = React.createContext(false);

export default (skeletonDummyData, pendingProps = ['pending']) => (WrappedComponent) => {
    const Wrapped = (props) => {
        const isPending = pendingProps.filter(pendingProp => props[pendingProp] === true).length !== 0;

        return (
            <PendingContext.Provider value={ isPending }>
                <WrappedComponent { ...props } { ...(isPending ? skeletonDummyData : {}) } />
            </PendingContext.Provider>
        );
    };

    return Wrapped;
};
